import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

import { Store } from '@ngrx/store';
import { tap, filter, take, switchMap, catchError, map } from 'rxjs/operators';

import * as fromStore from '../store';
import { combineLatest, Observable, of } from 'rxjs';
import { StringUtility } from '@teamfoster/sdk/text-utility';

@Injectable({ providedIn: 'root' })
export class CustomerGuard {
  constructor(private store: Store) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    return this.checkStore(route).pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  checkStore(route: ActivatedRouteSnapshot): Observable<boolean> {
    return combineLatest([
      this.store.select(fromStore.getCustomerLoaded),
      this.store.select(fromStore.getCustomerLoading),
      this.store.select(fromStore.getTokenInitialized),
      this.store.select(fromStore.getCustomerAccessToken),
    ]).pipe(
      tap(([loaded, loading, initialized, token]) => {
        if (!loaded && !loading && initialized && token) {
          this.store.dispatch(fromStore.LoadCustomer());
        }
      }),
      map(([loaded, loading, initialized, token]) => loaded),
      // filter(loaded => loaded),
      take(1)
    );
  }
}
